import React, { PureComponent } from 'react';
import classNames from 'classnames';

import TheatrePortal from '../TheatrePortal';

import { container, titleRow, title as titleStyle } from './styles.module.css';

class Panel extends PureComponent {
  render() {
    const {
      className: clientClassName,
      title,
      leftTitleRenderProp,
      rightTitleRenderProp,
      children,
      onClose,
      hideTitle,
    } = this.props;
    return (
      <TheatrePortal onClose={onClose}>
        <div className={classNames(container, clientClassName)}>
          {!hideTitle && (
            <div className={titleRow}>
              <span>{leftTitleRenderProp && leftTitleRenderProp()}</span>
              <span className={titleStyle}>{title}</span>
              <span>{rightTitleRenderProp && rightTitleRenderProp()}</span>
            </div>
          )}
          {children}
        </div>
      </TheatrePortal>
    );
  }
}

Panel.propTypes = {};

Panel.defaultProps = {};

export default Panel;
